export default __webpack_public_path__ + "static/cadre_noir-7056dd062e8acd7d99fc7585f37cbf18.png";